<se-fe-empty-state [seFeDataTitle]="title()">
  <se-fe-icon seFeEmptyStateIcon seFeDataName="spot_clipboard" seFeDataSize="950" seFeDataColor="gray-900"></se-fe-icon>
  <span data-testid="error-message">{{ message() }}</span>
</se-fe-empty-state>
